import LayerAdminService from "./LayerAdminService";

export default class RouteLineService extends LayerAdminService {
  private _lbBaseUrl = process.env.REACT_APP_LB_URL;

  public async StartRouteLineImport(file: File, quarter: string): Promise<any> {
    const formData = new FormData();
    formData.append("routeLineArchive", file);

    return this._client
      .post<any>(`${this._endpoint}/Basemap:RouteLine/${quarter}`, formData, {
        timeout: 0,
        baseURL: this._lbBaseUrl,
      })
      .then((response) => {
        return response.data;
      });
  }

  public async deleteRouteLine(importId: string): Promise<any> {
    return this._client
      .delete<any>(`${this._endpoint}/Basemap:RouteLine/${importId}`, {
        baseURL: this._lbBaseUrl,
      })
      .then((response) => {
        return response.data;
      });
  }
}
